import React from 'react'
import PropTypes from 'prop-types'
import withLayout from '../../../layout/withLayout'
import ContentBox from '../../../layout/component/ContentBox'
import { lifecycle } from 'recompose'
import { renderProcessName, renderStateName } from '../../util/names'
import Select from '../../../form/component/Select'
import { STATE_RESPONSIBLE_SELECT } from '../../state/state-responsible/const'


const StateResponsible = ({ stateResponsible, changeStateResponsible, saveStateResponsible }) => {
    return (
        <tr>
            <td>{renderProcessName(stateResponsible.processName)}</td>
            <td>{renderStateName(stateResponsible.stateName)}</td>
            <td>
                <Select
                    object={stateResponsible}
                    name="responsible"
                    valueList={STATE_RESPONSIBLE_SELECT}
                    onChange={(name, value) => {
                        changeStateResponsible(stateResponsible.id, name, value)
                        saveStateResponsible(stateResponsible.id)
                    }}
                />
            </td>
        </tr>
    )
}


const StateResponsibleConfiguration = ({ stateResponsibleList, changeStateResponsible, saveStateResponsible }) => {
    return (
        <ContentBox title="State Responsible">
            <table className="default-table">
                <thead>
                    <tr>
                        <th>Process name</th>
                        <th>State name</th>
                        <th>Responsible</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        stateResponsibleList.map(stateResponsible => {
                            return (<StateResponsible
                                key={stateResponsible.id}
                                stateResponsible={stateResponsible}
                                changeStateResponsible={changeStateResponsible}
                                saveStateResponsible={saveStateResponsible}
                            />

                            )
                        })
                    }
                </tbody>
            </table>

        </ContentBox>
    )
}


StateResponsibleConfiguration.propTypes = {
    stateResponsibleList: PropTypes.array.isRequired,

    findResponsibleStateList: PropTypes.func.isRequired,
    changeStateResponsible: PropTypes.func.isRequired,
    saveStateResponsible: PropTypes.func.isRequired,
}

export default lifecycle({
    componentDidMount () {
        this.props.findResponsibleStateList()
    },
})(withLayout(StateResponsibleConfiguration))





// WEBPACK FOOTER //
// ./src/modules/process/component/state-responsible/StateResponsibleConfiguration.js